import { Parametrized } from '@flippingbook/web.utils/dist/service';
import type { IHttpClient } from '@flippingbook/web.utils/dist/webservice';

import type { BasicErrorResponse } from './interfaces/ServiceResponse';

export class SamlApi extends Parametrized<SamlApi.Params> {
    verifySamlIdp(params: SamlApi.VerifySamlIdpParams) {
        const { IdpName } = params;

        return this.params.httpClient.fetchUrl<BasicErrorResponse>(
            `/api/saml/verify-idp/${encodeURIComponent(IdpName)}`,
            {
                method: 'POST',
            },
        );
    }

    navigateToSamlProvider(params: SamlApi.NavigateToSamlProviderParams) {
        const { IdpName, Query } = params;

        const query = Query ? `?${Query}` : '';

        window.location.assign(`/api/saml/login/${encodeURIComponent(IdpName)}${query}`);
    }
}

export namespace SamlApi {
    export interface VerifySamlIdpParams {
        IdpName: string;
    }
    export interface NavigateToSamlProviderParams {
        IdpName: string;
        Query?: string;
    }

    export interface Params {
        httpClient: IHttpClient;
    }
}
